export default "__VITE_ASSET__ed82a433__"